import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { AutoCheckoutService } from 'src/app/services/auto-checkout/auto-checkout.service';
import { CheckoutServiceService } from 'src/app/services/checkout/checkout-service.service';

@Component({
  selector: 'app-checkout-form',
  templateUrl: './checkout-form.component.html',
  styleUrls: ['./checkout-form.component.scss'],
})
export class CheckoutFormComponent implements OnInit {
  @Input() storeId: string;
  public destinationOptionList: string[];
  public terminalOptionList: string[];
  public orderHoursRestriction: string;
  public checkoutForm: FormGroup;
  private questionSet: any;
  public todayDate: any;
  constructor(private autoCheckoutService: AutoCheckoutService, private checkoutService: CheckoutServiceService, private modalController: ModalController) {
    this.destinationOptionList = [];
    this.questionSet = {
      first_name: {
        id: '12',
        label: 'Enter First Name'
      },
      last_name: {
        id: '13',
        label: 'Enter Last Name'
      },
      email: {
        id: '11',
        label: 'Enter Email'
      },
      phone_number: {
        id: '24',
        label: 'Enter Phone Number'
      },
      pickup_date: {
        id: '17',
        label: 'Enter Pickup Date'
      },
      pickup_time: {
        id: '18',
        label: 'Enter Pickup Time'
      },
      destination: {
        id: '16',
        label: 'Select Travel Destination'
      },
      terminal: {
        id: '23',
        label: 'Select Terminal'
      },
      flight_no: {
        id: '28',
        label: 'Enter Flight Number'
      },
    };
  }
  ngOnInit(): void {

  }
  ionViewDidEnter() {
    // TODO: Handle latest allowed order time: Need to make sure the store accepts the order close to delivery
    let formFields: any = {} as any;
    formFields.first_name = new FormControl('', [Validators.required, Validators.minLength(3)]);
    formFields.last_name = new FormControl('', [Validators.required, Validators.minLength(3)]);
    formFields.email = new FormControl('', [Validators.required, Validators.email]);
    formFields.pickup_date = new FormControl('', [Validators.required]);
    formFields.flight_no = new FormControl('', [Validators.required]);
    formFields.pickup_time = new FormControl('', [Validators.required]);
    formFields.phone_number = new FormControl('', [
      Validators.required,
      Validators.pattern('^[0-9]{10}$'),
    ]);

    this.autoCheckoutService.getAutoCheckoutForm(this.storeId).subscribe((response) => {
      if (response.questions && response.questions.length > 0) {
        let questionSet = response.questions;
        // if(response && response.pickup_start_time){
        //   this.orderHoursRestriction =
        // }
        questionSet.map((item) => {
          if (item.name === 'destination') {
            this.destinationOptionList = item.optionList;
            formFields.destination = new FormControl('', [Validators.required]);
          }
          if (item.name === 'terminal') {
            this.terminalOptionList = item.optionList;
            formFields.terminal = new FormControl('', [Validators.required]);
          }
        });
        this.checkoutForm = new FormGroup(formFields);
      }
    });
  }

  submitRequest() {
    let requestData = [];
    Object.keys(this.checkoutForm.value).forEach((key) => {
      requestData.push({
        answer: this.checkoutForm.value[key],
        question: this.questionSet[key].label,
        questionId: this.questionSet[key].id
      });
    });
    this.modalController.dismiss(
      {
        formInfo: requestData,
        userInfo: {
          Name: this.checkoutForm.value.first_name + ' ' + this.checkoutForm.value.last_name,
          Email: this.checkoutForm.value.email,
          number: this.checkoutForm.value.phone_number
        }
      }
    );

    // this.checkoutService.checkoutCart
  }
}
